import React from "react";
import { useViewport } from 'components/general/useViewPort'
import Label from "components/general/Label"
import Horse from "components/presentation/Horse";
import Competitor from "components/presentation/Competitor";
import { NocMemo as Noc } from "components/presentation/Noc";
import SportCode from "components/common/SportCode";

export const DressagePreviousGP = (props) => {
    const { data, teamData, teamAfter, officials } = props;

    const positions = officials?.filter(o => o?.extensions?.find(e => e?.oe_code === 'JURY'))?.map(o => ({order: o?.order+'', position: o?.extensions?.find(e => e?.oe_code === 'JURY')?.oe_value}))?.sort((a, b) => a?.order -b?.order);

    const { breakPoint } = useViewport()
    
    const isMobile = breakPoint === 'sm' || breakPoint === 'xs';  

    if (!positions) return <></>;
    return (
        <>
            { !data ? <></> : isMobile ?  <ResultBoxXs data={data} teamData={teamData} teamAfter={teamAfter} positions={positions} /> : <ResultBoxXl data={data}  teamData={teamData} teamAfter={teamAfter} positions={positions} />}
        </>
    );
}

const ResultBoxXl = (props) => {
    const { data, teamData, teamAfter, positions } = props;
    const irm = data?.resultIrm ? <SportCode discipline='EQU' entity='@IRM' code={data.resultIrm} abbr={true} isAddLegend={false} /> : <></> 
    const irmTeam = teamData?.resultIrm ? <SportCode discipline='EQU' entity='@IRM' code={teamData.resultIrm} abbr={true} isAddLegend={false} /> : <></> 
    return (
        <table className="table table-sm table-bordered border">
            <caption><Label data='HeaderPreviousComp'/></caption>
            <thead>
                <tr>
                    <td className="fw-bold w-5 text-end mirs-break-line" rowSpan={2}><Label data="LabelStartOrder" /></td>
                    <td className="fw-bold w-30 text-start mirs-break-line" rowSpan={2}><Label data="HeaderAthleteHorse" /></td>
                    <td className="text-start w-5" rowSpan={2}></td>
                    <td className="fw-bold  text-center" colSpan={positions.length}><Label data="HeaderPercentScore" /></td>
                    <td className="text-end w-5 fw-bold mirs-break-line" rowSpan={2}><Label data="HeaderTotPercentScore" /></td>
                    <td className="text-end w-5 fw-bold mirs-break-line" rowSpan={2}><Label data="HeaderRank" /></td>
                </tr>
                <tr>
                    {positions?.map(p => {
                        return (
                            <td className="w-5 text-end fw-bold" key={p.order}>{p.position}</td>
                        )
                    })}
                </tr>

            </thead>
            <tbody>
                <tr>
                    <td className="w-10 text-end">{data?.startOrder}</td>
                    <td className="text-start">
                        <div className='d-flex align-items-center'>
                            <div className='d-none d-md-block me-1'>
                                <Noc className='me-1' {...data?.participant?.organisation} />
                            </div>
                            <div>
                                <Competitor hidePicture={true} {...data?.participant} />
                            </div> 
                        </div>
                        <div className="">
                            <Horse {...data?.horse}/>                                   
                        </div> 
                    </td>
                    <td className="tex-star">{teamData ? 'T' : ''}</td>
                        {positions?.map(p => {
                            const res = data?.extendedResults?.find(er => er?.er_code === 'D_JUDGE' && er?.er_pos === p?.order)?.er_value;
                            return (
                                <td className="w-5 text-end" key={p.order}>{res}</td>
                            )
                        })}
                    <td className="text-end align-middle" >{data?.resultData} {irm}</td>
                    <td className="text-end align-middle">{data?.resultRank}</td>
                </tr>
                {teamData && 
                    <>
                        <tr  className="bg-table-header">
                            <td className="fw-bold text-center"></td>
                            <td colSpan={2 + positions.length} className="fw-bold text-center">{teamAfter && <Label data="LabelTeamResAfterComposed" values={{ teamAfter: teamAfter }} />}</td>
                            <td className="text-end w-5 fw-bold mirs-break-line"><Label data="HeaderTotPercentScore" /></td>
                            <td className="text-end w-5 fw-bold mirs-break-line"><Label data="HeaderRank" /></td>
                        </tr>
                        <tr >
                            <td className="fw-bold text-center"></td>
                            <td colSpan={2 + positions.length}>
                                <div className='d-flex align-items-center'>
                                    <div className='d-none d-md-block me-1'>
                                        <Noc className='me-1' {...teamData?.participant?.organisation} />
                                    </div>
                                    <div>
                                        <Competitor hidePicture={true} {...teamData?.participant} />
                                    </div>                                    
                                </div>
                            </td>
                            <td className="text-end align-middle" >{teamData?.resultData} {irmTeam}</td>
                            <td className="text-end align-middle">{teamData?.resultRank}</td>
                        </tr>
                    </>
                }
            </tbody>
        </table>
    );
}

const ResultBoxXs = (props) => {
    const { data, teamData, teamAfter, positions } = props;
    const irm = data?.resultIrm ? <SportCode discipline='EQU' entity='@IRM' code={data.resultIrm} abbr={true} isAddLegend={false} /> : <></> 
    const irmTeam = teamData?.resultIrm ? <SportCode discipline='EQU' entity='@IRM' code={teamData.resultIrm} abbr={true} isAddLegend={false} /> : <></> 
    return (
        <table className="table table-sm table-bordered border">
            <thead>
                <tr>
                    <td className="text-start fw-bold"><Label data={'HeaderPreviousComp'} /></td>
                    <td className="text-start fw-bold"></td>
                    <td className="text-end w-5 fw-bold mirs-break-line"><Label data="HeaderTotPercentScore" /></td>
                    <td className="text-end w-5 fw-bold mirs-break-line"><Label data="HeaderRank" /></td>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td className="text-start"><Competitor {...data?.participant} alwaysNoc={true} hidePicture={true}/> <Horse {...data?.horse}/></td>
                    <td className="tex-star">{teamData ? 'T' : ''}</td>
                    <td className="text-end align-middle" >{data?.resultData} {irm}</td>
                    <td className="text-end align-middle">{data?.resultRank}</td>
                </tr>
                {teamData && 
                    <>
                        <tr>
                            <td colSpan={2}>
                                <div className='d-flex align-items-center'>
                                    <div className='d-none d-md-block me-1'>
                                        <Noc className='me-1' {...teamData?.participant?.organisation} />
                                    </div>
                                    <div>
                                        <Competitor hidePicture={true} {...teamData?.participant} />
                                    </div>                                    
                                </div>
                            </td>
                            <td className="text-end align-middle" >{teamData?.resultData} {irmTeam}</td>
                            <td className="text-end align-middle">{teamData?.resultRank}</td>
                        </tr>
                    </>
                }
            </tbody>
        </table>
    );

}

